import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import AziCodeLogo from "../assets/Main/logominiblack.svg";

export default function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.desktop}>
        <div className={classes.limit}>
          <Typography className={classes.texto}>
            Todos os direitos reservados © 2021
          </Typography>
          <div className={classes.desenvolvido}>
            <Typography className={classes.texto}>Desenvolvido por</Typography>
            <a
            href="https://azicode.com.br" className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            >
              <img src={AziCodeLogo} alt="AZI Code" className={classes.emakers} />
              <Typography className={classes.aziTexto}>AZI Code</Typography>
            </a>
          </div>
        </div>
      </div>
      <div className={classes.mobile}>
        <div className={classes.footerM}>
          <Typography className={classes.textoM}>
            Todos os direitos reservados © 2021
          </Typography>
          <div className={classes.desenvolvido}>
            <Typography className={classes.textoM}>Desenvolvido por</Typography>
            <a
            href="https://azicode.com.br" className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            >
              <img src={AziCodeLogo} alt="AZI Code" className={classes.emakersM} />
              <Typography className={classes.aziTextoM}>AZI Code</Typography>
            </a>
          </div>
        </div>
        <div className={classes.espacoAppbar} />
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.darkBlue,
  },
  limit: {
    width: "100%",
    maxWidth: "1376px",
    paddingRight: "5px",
    paddingLeft: "5px",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    display: "flex",
  },
  desktop: {
    height: "30px",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  footerM: {
    height: "25px",
    width: "100vw",
    paddingRight: "5px",
    paddingLeft: "5px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
  },
  texto: {
    color: theme.colors.white,
    fontSize: "14px",
  },
  textoM: {
    color: theme.colors.white,
    fontSize: "10px",
  },
  aziTexto: {
    color: theme.colors.white,
    fontSize: "14px",
    marginLeft: "5px",
  },
  aziTextoM: {
    color: theme.colors.white,
    fontSize: "10px",
    marginLeft: "5px",
  },
  emakers: {
    marginLeft: "5px",
    height: "20px",
    alignSelf: "center",
    display: "block",
    filter: "invert(1)",
  },
  emakersM: {
    marginLeft: "5px",
    height: "16px",
    alignSelf: "center",
    display: "block",
    filter: "invert(1)",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    display: "flex",
  },
  espacoAppbar: {
    height: "65px",
  },
  desenvolvido: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
  },
  link: {
    height: "100%",
    alignItems: "center",
    display: "flex",
  },
}));
